import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Menu,
  MenuItem,
  Button
} from '@mui/material';
import { useState } from 'react';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

WalletEventsListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function WalletEventsListToolbar({ numSelected, filterName, onFilterName, handleStatus, handleDate }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  // menu section---
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? 'primary.lighter' : 'primary.dark'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Search user..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}

      {/* <Box>
        <IconButton onClick={() => handleDate(null)}>
          <Icon icon="eva:refresh-fill" />
        </IconButton>
        <Button
          variant="contained"
          onClick={() => {
            const f = new Date();
            const fechaAct = `${f.getDate()}-${f.getMonth() + 1}-${f.getFullYear()}`;
            const millis = Date.parse(`${f.getFullYear()}-${f.getMonth() + 1}-${f.getDate()}`);
            handleDate(millis);

            console.log('fecha', fechaAct, 'millis', millis);
          }}
        >
          Hoy
        </Button>
      </Box> */}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filtrar por estatus">
          <IconButton
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <Icon icon={roundFilterList} />
          </IconButton>
        </Tooltip>
      )}

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={() => handleStatus(null)}>Todos</MenuItem>
        <MenuItem onClick={() => handleStatus('SERVICIO')}>Pago Servicios</MenuItem>
        <MenuItem onClick={() => handleStatus('PAQUETERIA')}>Pago Paqueteria</MenuItem>
        <MenuItem onClick={() => handleStatus('RECARGA')}>Pago Recarga</MenuItem>
        {/* <MenuItem onClick={() => handleStatus('CANCELADO')}>Cancelado</MenuItem> */}
      </Menu>
    </RootStyle>
  );
}
